<div *ngIf="loading" class="loading-text">
  <p>{{ 'PleaseWaitDataLoading' | translate }}</p>
</div>

<div *ngIf="!loading">

<app-sub-header [pageTitle]="getPageTitle()"></app-sub-header>

<div class="padded-container">
    <dx-form>
      <dxi-item [label]="{text: 'VisualDamageDeffectPosition' | translate}">
        <dx-text-box [(value)]="visualDamageDeffectPosition" class="full-width-button"></dx-text-box>
      </dxi-item>
      <dxi-item [label]="{ text: 'AccidentDescription' | translate }">
        <dx-text-area [(value)]="accidentDescription" class="full-width-button" [autoResizeEnabled]="true"></dx-text-area>
      </dxi-item>
      <dxi-item [label]="{ text: 'DamageDescription' | translate }">
        <dx-text-area [(value)]="damageDescription" class="full-width-button" [autoResizeEnabled]="true"></dx-text-area>
      </dxi-item>
      <dxi-item [label]="{ text: 'AccidentPlace' | translate }">
        <dx-text-box [(value)]="accidentPlace" class="full-width-button"></dx-text-box>
      </dxi-item>
      <dxi-item [label]="{ text: 'AccidentTime' | translate }">
            <dx-select-box [(value)]="startHours" [items]="hoursArray" class="full-width-button"></dx-select-box>
            <dx-select-box [(value)]="startMinutes" [items]="minutesArray" class="full-width-button"></dx-select-box>
      </dxi-item>
      <dxi-item [label]="{ text: 'Date' | translate }">
<dx-date-box [(value)]="choosedDate" displayFormat="dd/MM/yyyy"></dx-date-box>
      </dxi-item>
    </dx-form>
        <dx-button text="{{ 'Save' | translate }}" (onClick)="save()" type="success" class="full-width-button"></dx-button>
        <dx-button text="{{ 'Back' | translate }}" (onClick)="backClick()" type="default" class="full-width-button"></dx-button>
        <dx-file-uploader
          selectButtonText="{{ 'AddAPhoto' | translate }}"
          accept="image/*"
          uploadMode="useForm"
          capture="camera"
          [inputAttr]="{ 'aria-label': 'Select Photo' }"
          (onValueChanged)="onFileUploaderValueChanged($event)"
          [multiple]="true"
          [allowCanceling]="true"
          labelText="{{ 'OrDropAFileHere' | translate }}">
        </dx-file-uploader>
      
        <ul>
          <li *ngFor="let file of uploadedFiles; let i = index">
            {{ file.name }}
            <dx-button (click)="deleteFile(i)" text="{{ 'Remove' | translate }}"></dx-button>
          </li>
        </ul>
  </div>
</div>